import React from 'react';
import { useNavigate } from 'react-router-dom';

const AboutPage: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#FCFCFC]">
      {/* Hero */}
      <div className="bg-gradient-to-r from-[#DAA520] to-[#E91E63] text-white py-20 px-4 text-center">
        <h1 className="text-4xl md:text-5xl font-bold mb-4">About Sasta Fashions</h1>
        <p className="text-lg text-white/80 max-w-2xl mx-auto">
          Fashion for everyone — affordable, quality clothing for the whole family.
        </p>
      </div>

      <div className="py-14 px-4 md:px-20 max-w-5xl mx-auto space-y-12">
        {/* Our Story */}
        <div className="bg-white rounded-xl shadow-sm p-8">
          <h2 className="text-2xl font-bold text-gray-800 mb-4">Our Story</h2>
          <p className="text-gray-600 leading-relaxed mb-4">
            SASTA DEAL PRIVATE LIMITED was founded with a simple belief — that great fashion shouldn't cost a fortune. We are a family-owned fashion brand based in West Bengal, India, dedicated to bringing high-quality clothing at prices everyone can afford.
          </p>
          <p className="text-gray-600 leading-relaxed">
            From colourful kids' wear to elegant women's ethnic collections and smart men's casuals, we curate every piece with care. Our festive sale prices ensure you always get premium quality at the most honest prices, with all taxes included — no surprises at checkout.
          </p>
        </div>

        {/* Values */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {[
            { icon: '👗', title: 'Quality First', desc: 'Every product is hand-picked for fabric quality, stitching, and durability. We only sell what we would wear ourselves.' },
            { icon: '💰', title: 'Honest Pricing', desc: 'All our prices are GST-inclusive. No hidden charges. What you see is what you pay — always.' },
            { icon: '🚚', title: 'Free Delivery', desc: 'We offer free shipping on every order across India. Fashion delivered to your doorstep at no extra cost.' },
          ].map(v => (
            <div key={v.title} className="bg-white rounded-xl shadow-sm p-6 text-center">
              <div className="text-4xl mb-3">{v.icon}</div>
              <h3 className="text-lg font-semibold text-gray-800 mb-2">{v.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed">{v.desc}</p>
            </div>
          ))}
        </div>

        {/* Collections */}
        <div className="bg-white rounded-xl shadow-sm p-8">
          <h2 className="text-2xl font-bold text-gray-800 mb-6">Our Collections</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {[
              { label: "Women's", desc: "Dresses, Sarees, Kurtis, Palazzo sets and Dupattas — over 100 styles for every occasion.", link: '/women', color: 'from-[#E91E63] to-[#DAA520]' },
              { label: "Men's", desc: "Shirts, T-shirts, Kurtas, Jackets and Pants — smart casuals to festive ethnic wear.", link: '/men', color: 'from-[#2196F3] to-[#DAA520]' },
              { label: "Kids'", desc: "Dresses, Dungarees, Lehengas, Tracksuits and more — fun and comfortable for little ones.", link: '/kids', color: 'from-[#4CAF50] to-[#DAA520]' },
            ].map(c => (
              <div key={c.label} className={`bg-gradient-to-br ${c.color} rounded-xl p-6 text-white`}>
                <h3 className="text-xl font-bold mb-2">{c.label}</h3>
                <p className="text-sm text-white/80 mb-4">{c.desc}</p>
                <button onClick={() => navigate(c.link)} className="bg-white/20 hover:bg-white/30 text-white text-sm px-4 py-2 rounded-lg font-medium">
                  Browse →
                </button>
              </div>
            ))}
          </div>
        </div>

        {/* Contact */}
        <div className="bg-white rounded-xl shadow-sm p-8">
          <h2 className="text-2xl font-bold text-gray-800 mb-4">Get in Touch</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-gray-600">
            <div>
              <h3 className="font-semibold text-gray-800 mb-2">📍 Address</h3>
              <p className="text-sm leading-relaxed">
                Floor No. Gr - Fr, Building No. 114/K,<br />
                Raja S.C. Mullick Road, Near Naktala,<br />
                Garia, Kolkata,<br />
                West Bengal – 700047
              </p>
            </div>
            <div>
              <h3 className="font-semibold text-gray-800 mb-2">✉️ Email</h3>
              <p className="text-sm"><a href="mailto:sastadealpvt@gmail.com" className="text-[#DAA520] hover:underline">sastadealpvt@gmail.com</a></p>
              <h3 className="font-semibold text-gray-800 mt-4 mb-2">🕐 Support Hours</h3>
              <p className="text-sm">Monday – Saturday, 10 AM – 6 PM IST</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
